import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import consola from 'consola';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
// import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import TcVars from '~/components/functional/TcVars/CustomizableHomePageTcVars.vue';
import { PRISMIC_URL } from '~/const/3rd';
import { components, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { formatPrismicImage } from '~/helpers/image-helper';
import { fetchBlogCategories, fetchContent, fetchDocumentsById } from '~/services/editorial';
export default {
  name: 'Article',
  components: {
    Seo: Seo,
    OpenGraph: OpenGraph,
    TcVars: TcVars
    // RatingJsonLd,
  },
  validate: function validate(_ref) {
    var _ref$params = _ref.params,
      alias = _ref$params.alias,
      slug = _ref$params.slug;
    return alias && (slug || 'landing');
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=3600, public'
    };
  },
  asyncData: function asyncData(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var error, _ref2$params, alias, _ref2$params$slug, slug, apolloProvider, store, _content$results, definition, content, _content$results2, _content$results2$, id, data, tags, blogCategories, slices, eventCategory, eventAction, eventLabel, tracking, articleRecommendationSlice, articleRecommendationItems, ids, _yield$fetchDocuments, results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            error = _ref2.error, _ref2$params = _ref2.params, alias = _ref2$params.alias, _ref2$params$slug = _ref2$params.slug, slug = _ref2$params$slug === void 0 ? 'landing' : _ref2$params$slug, apolloProvider = _ref2.app.apolloProvider, store = _ref2.store;
            _context.prev = 1;
            definition = typeDefinition(alias);
            _context.next = 5;
            return fetchContent(store, {
              type: definition.type,
              slug: slug,
              alias: alias
            });
          case 5:
            content = _context.sent;
            if (content !== null && content !== void 0 && (_content$results = content.results) !== null && _content$results !== void 0 && _content$results.length) {
              _context.next = 9;
              break;
            }
            error({
              statusCode: 404,
              message: 'Not Found'
            });
            return _context.abrupt("return", false);
          case 9:
            _content$results2 = _slicedToArray(content.results, 1), _content$results2$ = _content$results2[0], id = _content$results2$.id, data = _content$results2$.data, tags = _content$results2$.tags;
            if (!(data.alias && data.alias !== alias)) {
              _context.next = 13;
              break;
            }
            error({
              statusCode: 404,
              message: 'Not Found'
            });
            return _context.abrupt("return", false);
          case 13:
            _context.next = 15;
            return fetchBlogCategories(store);
          case 15:
            blogCategories = _context.sent;
            _context.next = 18;
            return buildSlices(definition, data, apolloProvider.defaultClient, store);
          case 18:
            slices = _context.sent;
            eventCategory = data.event_category, eventAction = data.event_action, eventLabel = data.event_label;
            tracking = {
              eventCategory: eventCategory,
              eventAction: eventAction,
              eventLabel: eventLabel
            };
            articleRecommendationSlice = data.body.filter(function (a) {
              return a.slice_type === 'article_recommendation';
            });
            articleRecommendationItems = articleRecommendationSlice.map(function (e) {
              return e.items;
            });
            ids = articleRecommendationItems.flat(1).map(function (e) {
              return e.article.id;
            });
            _context.next = 26;
            return fetchDocumentsById(store, ids);
          case 26:
            _yield$fetchDocuments = _context.sent;
            results = _yield$fetchDocuments.results;
            return _context.abrupt("return", {
              results: results,
              blogCategories: blogCategories,
              type: definition.type,
              template: {
                path: definition.path,
                data: data,
                tracking: tracking
              },
              id: id,
              tags: tags,
              slices: slices
            });
          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](1);
            error({
              statusCode: 404,
              message: 'Not Found'
            });
            return _context.abrupt("return", false);
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 31]]);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    tcVars: function tcVars() {
      return this.template ? _objectSpread(_objectSpread({}, this.template.data), {}, {
        env_template: this.template.data.env_template || 'Landing Page'
      }) : {};
    },
    blogCategory: function blogCategory() {
      var _this$blogCategories$,
        _this = this;
      if (this.type !== 'article') return null;
      return (_this$blogCategories$ = this.blogCategories.find(function (item) {
        return item.data.category_label === _this.tags[0];
      })) === null || _this$blogCategories$ === void 0 ? void 0 : _this$blogCategories$.uid;
    }
  }),
  created: function created() {
    var _this2 = this;
    if (this.template.path) {
      this[this.type] = function () {
        return components[_this2.type](_this2.template.path);
      };
    }
    this.slices.forEach(function (_ref3) {
      var type = _ref3.type,
        path = _ref3.path;
      _this2[type] = function () {
        return components[type](path);
      };
    });
  },
  beforeMount: function beforeMount() {
    var _this3 = this;
    var prismicEdit = this.$cookies.get('editor');
    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(function () {}).catch(function (err) {
        consola.error('PRISMIC FAILED', err);
        _this3.$logger.error("PRISMIC FAILED ".concat(err));
      });
    }
  },
  methods: {
    currentComponent: function currentComponent(arg) {
      return this[arg];
    },
    options: function options(_ref4) {
      var backgroundColor = _ref4.global_background_color,
        image = _ref4.global_background_image;
      return process.browser ? _objectSpread(_objectSpread({}, backgroundColor && {
        style: {
          backgroundColor: backgroundColor
        }
      }), image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    }
  }
};